import BalanceTooltip from "src/components/wallets/header/BalanceTooltip";

interface CompletedIconProps {
  tooltip: string;
}

const CompletedIcon = ({ tooltip }: CompletedIconProps) => {
  return (
    <BalanceTooltip message={tooltip}>
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1686_3380)">
          <mask id="path-1-inside-1_1686_3380" fill="white">
            <path d="M6 -6.10352e-05C2.688 -6.10352e-05 0 2.68794 0 5.99994C0 9.31194 2.688 11.9999 6 11.9999C9.312 11.9999 12 9.31194 12 5.99994C12 2.68794 9.312 -6.10352e-05 6 -6.10352e-05ZM4.8 8.99994L1.8 5.99994L2.646 5.15394L4.8 7.30194L9.354 2.74794L10.2 3.59994L4.8 8.99994Z" />
          </mask>
          <path
            d="M6 -6.10352e-05C2.688 -6.10352e-05 0 2.68794 0 5.99994C0 9.31194 2.688 11.9999 6 11.9999C9.312 11.9999 12 9.31194 12 5.99994C12 2.68794 9.312 -6.10352e-05 6 -6.10352e-05ZM4.8 8.99994L1.8 5.99994L2.646 5.15394L4.8 7.30194L9.354 2.74794L10.2 3.59994L4.8 8.99994Z"
            fill="#002035"
          />
          <path
            d="M4.8 8.99994L-6.51371 20.3136L4.8 31.6274L16.1137 20.3136L4.8 8.99994ZM1.8 5.99994L-9.51371 -5.31377L-20.8274 5.99994L-9.51371 17.3136L1.8 5.99994ZM2.646 5.15394L13.9439 -6.17554L2.63023 -17.4577L-8.66771 -6.15977L2.646 5.15394ZM4.8 7.30194L-6.49792 18.6314L4.81577 29.9136L16.1137 18.6156L4.8 7.30194ZM9.354 2.74794L20.7076 -8.52572L9.39405 -19.9195L-1.95971 -8.56577L9.354 2.74794ZM10.2 3.59994L21.5137 14.9136L32.7875 3.63985L21.5536 -7.67372L10.2 3.59994ZM6 -6.10352e-05V-16.0001C-6.14856 -16.0001 -16 -6.14862 -16 5.99994H0H16C16 11.5245 11.5246 15.9999 6 15.9999V-6.10352e-05ZM0 5.99994H-16C-16 18.1485 -6.14856 27.9999 6 27.9999V11.9999V-4.00006C11.5246 -4.00006 16 0.475383 16 5.99994H0ZM6 11.9999V27.9999C18.1486 27.9999 28 18.1485 28 5.99994H12H-4C-4 0.475383 0.475444 -4.00006 6 -4.00006V11.9999ZM12 5.99994H28C28 -6.14862 18.1486 -16.0001 6 -16.0001V-6.10352e-05V15.9999C0.475444 15.9999 -4 11.5245 -4 5.99994H12ZM4.8 8.99994L16.1137 -2.31377L13.1137 -5.31377L1.8 5.99994L-9.51371 17.3136L-6.51371 20.3136L4.8 8.99994ZM1.8 5.99994L13.1137 17.3136L13.9597 16.4676L2.646 5.15394L-8.66771 -6.15977L-9.51371 -5.31377L1.8 5.99994ZM2.646 5.15394L-8.65192 16.4834L-6.49792 18.6314L4.8 7.30194L16.0979 -4.02754L13.9439 -6.17554L2.646 5.15394ZM4.8 7.30194L16.1137 18.6156L20.6677 14.0616L9.354 2.74794L-1.95971 -8.56577L-6.51371 -4.01177L4.8 7.30194ZM9.354 2.74794L-1.99962 14.0216L-1.15362 14.8736L10.2 3.59994L21.5536 -7.67372L20.7076 -8.52572L9.354 2.74794ZM10.2 3.59994L-1.11371 -7.71377L-6.51371 -2.31377L4.8 8.99994L16.1137 20.3136L21.5137 14.9136L10.2 3.59994Z"
            fill="#002035"
            mask="url(#path-1-inside-1_1686_3380)"
          />
        </g>
        <defs>
          <clipPath id="clip0_1686_3380">
            <rect width="12" height="12" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </BalanceTooltip>
  );
};

export default CompletedIcon;
